import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'forbidden',
  template: require('./forbidden.html')

})
export class Forbidden {
  params;

  constructor(public route: ActivatedRoute) {
  }

  ngOnInit() {
    this.params = this.route.snapshot.params;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/no-content/forbidden.ts